import $ from 'jquery';
// import { Component } from '../component';
// import Log from '../../helpers/log';

export class AccountDocuments {
    /**
     * constructor
     */
    constructor() {
        this.namespace = 'c-account-documents';
        this.classes = {
            element: `${ this.namespace }`,
            field: `${ this.namespace }__field`,
            items: `${ this.namespace }__items`,
            remove: `${ this.namespace }__remove`,
            placeholder: `${ this.namespace }__placeholder`,
            add: `${ this.namespace }__add`,
            item: `${ this.namespace }__item`,
            itemUploaded: `${ this.namespace }__item--uploaded`,
        };
        this.limit = 10;
        this.files = [];
        this.total = 0;
        this.initialize();
    }

    /**
     * setup
     */
    initialize() {

        const $element = $( `.js-${ this.classes.element }` );
        if ( ! $element.length ) {
            return;
        }

        $element.each( ( index, el ) => {
            const $el = $( el );
            const $items = $el.find( `.${ this.classes.items }` );
            const $item = $items.find( `.${ this.classes.item }` );
            const total = $item.filter( ( itemNr, item ) => {
                return $( item ).hasClass( this.classes.itemUploaded );
            } ).length;

            this.setTotal( total );
        } );

        // Log.log(this,'AccountGallery');

        // if( $('#terms').length !==0 ) {
        //     if (! $('#terms').is('checked')) {
        //         $('.js-c-account-documents__add').hide();
        //     } else {
        //         $('.js-c-account-documents__add').show();
        //     }
        // }
        //
        // $('#terms').on('click change', function(e) {
        //     if (! $('#terms').is('checked')) {
        //         $('.js-c-account-documents__add').hide();
        //     } else {
        //         $('.js-c-account-documents__add').show();
        //     }
        // });

        // Bind events
        $( document ).on( 'change', `.js-${ this.classes.field }`, this.add.bind( this ) );
        $( document ).on( 'click', `.js-${ this.classes.remove }`, this.remove.bind( this ) );
    }

    /**
     * setTotal
     *
     * @param {number} total
     */
    setTotal( total ) {
        this.total = total;
    }

    /**
     * getTotal
     *
     * @return {number}
     */
    getTotal() {
        return this.total;
    }

    /**
     * add
     *
     * @param {object} evt
     */
    add( evt ) {
        const $el = $( evt.target );
        const $id = $el.attr( 'id' );
        const $documents = $( `[for="${ $id }"]` ).first().closest( `.js-${ this.classes.element }` );
        const $documentsItems = $documents.find( `.${ this.classes.items }` );
        const $documentsItem = $documentsItems.find( `.${ this.classes.item }` );

        // Log.log({$el});

        const $alert = $documents.find( '.alert' );
        if ( $alert.length ) {
            $alert.remove();
        }

        const data = new window.FormData();

        const files = evt.target.files;
        if ( ! files.length ) {
            return false;
        }

        if ( ( files.length + this.getTotal() ) > this.limit || this.getTotal() >= this.limit ) {
            $documents.append( `<div class="alert alert-danger mt-9 mb-0" role="alert">${ spauto_settings.i18n.max_images_limit }</div>`.replace( '%limit%', this.limit ) );

            return false;
        }

        $.each( files, ( index, file ) => {
            this.files.push( file );
        } );

        if ( $documents.is( '.is--processing' ) ) {
            return false;
        }

        $documents.addClass( 'is--processing' ).block( {
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6,
            },
        } );

        $.each( this.files, ( index, file ) => {
            data.append( 'documents[]', file, file.name );
        } );

        data.append( 'security', spauto_settings.save_profile_documents_nonce ); // eslint-disable-line no-undef
        data.append( 'terms', $documents.find( 'input[name="terms"]' ).is( ':checked' ) ); // eslint-disable-line no-undef

        $.ajax( {
            type: 'POST',
            url: spauto_settings.spauto_ajax_url.toString().replace( '%%endpoint%%', 'save_profile_documents' ), // eslint-disable-line no-undef
            data: data,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: ( response ) => {
                const successStatus = response.success;
                const errorStatus = ! response.success;

                // $documents.removeClass( 'is--processing' ).unblock();
                //
                // if ( errorStatus ) {
                //     $documents.append( `<div class="alert alert-danger mt-9 mb-0" role="alert">${ response.data.error }</div>` );
                // } else if ( successStatus ) {
                //     const errors = response.data.errors;
                //     if ( errors ) {
                //         $.each( errors, ( index, error ) => {
                //             $documents.append( `<div class="alert alert-danger mt-9 mb-0" role="alert">${ error }</div>` );
                //         } );
                //     }
                //
                //     const uploadedFiles = response.data.files;
                //     if ( uploadedFiles ) {
                //         $.each( uploadedFiles, ( index, file ) => {
                //             const total = this.getTotal();
                //             $documentsItem.eq( total ).html( this.renderItem( file ) ).addClass( this.classes.itemUploaded );
                //             $documentsItem.eq( total + 1 ).html( this.renderAddBtn() );
                //
                //             this.setTotal( total + 1 );
                //         } );
                //     }
                // }

                $documents.removeClass( 'is--processing' ).unblock();

                if ( errorStatus ) {
                    $documents.append( `<div class="alert alert-danger mt-30" role="alert">${ response.data.error }</div>` );
                } else if ( successStatus ) {
                    const errors = response.data.errors;
                    if ( errors ) {
                        $.each( errors, ( index, error ) => {
                            $documents.append( `<div class="alert alert-danger mt-30" role="alert">${ error }</div>` );
                        } );
                    }

                    const uploadedFiles = response.data.files;
                    if ( uploadedFiles ) {
                        $.each( uploadedFiles, ( index, file ) => {
                            const total = this.getTotal();

                            $documentsItems.append( this.renderItem( file ).addClass( this.classes.itemUploaded ) );

                            this.setTotal( total + 1 );
                        } );
                    }
                }

                this.files = [];
                $el.closest( 'form' ).get( 0 ).reset();
            },
            error: ( jqXHR, textStatus, errorMessage ) => {
                this.files = [];
                $el.closest( 'form' ).get( 0 ).reset();

                $documents.removeClass( 'is--processing' ).unblock();
                $documents.append( `<div class="alert alert-danger mt-20 mb-0" role="alert">${ errorMessage }</div>` );

                // Log.log( $el.closest( 'form' ).get( 0 ), 'form' );
                // Log.log( errorMessage );
            },
        } );

        return false;
    }

    /**
     * remove
     *
     * @param {object} evt
     */
    remove( evt ) {
        const $el = $( evt.currentTarget );
        const $documents = $el.closest( `.${ this.classes.element }` );
        const $documentsItems = $el.closest( `.${ this.classes.items }` );
        const $documentsItem = $el.closest( `.${ this.classes.item }` );
        const total = this.getTotal();
        const fileId = parseInt( $el.data( 'id' ) || 0 );

        const $alert = $documents.find( '.alert' );
        if ( $alert.length ) {
            $alert.remove();
        }

        if ( ! fileId ) {
            return false;
        }

        if ( $documents.is( '.is--processing' ) ) {
            return false;
        }

        $documents.addClass( 'is--processing' ).block( {
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6,
            },
        } );

        $.ajax( {
            type: 'POST',
            url: spauto_settings.spauto_ajax_url.toString().replace( '%%endpoint%%', 'delete_profile_document' ),
            data: {
                file_id: fileId,
                security: spauto_settings.delete_profile_document_nonce // eslint-disable-line no-undef
            },
            dataType: 'json',
            success: ( response ) => {
                const successStatus = response.success;
                const errorStatus = ! response.success;

                $documents.removeClass( 'is--processing' ).unblock();

                if ( errorStatus ) {
                    $documents.append( `<div class="alert alert-danger mt-20 mb-0" role="alert">${ response.data.error }</div>` );
                } else if ( successStatus ) {
                    // if ( total === this.limit ) {
                    //     $documentsItem.html( this.renderAddBtn() );
                    // }
                    // else {
                    //     $documentsItem.remove();
                    //     $documentsItems.append( this.renderEmptyItem() );
                    // }
                    $documentsItem.remove();

                    if ( total >= 1 ) {
                        this.setTotal( total - 1 );
                    }
                }


            },
            error: function( jqXHR, textStatus, errorMessage ) {

                $documents.removeClass( 'is--processing' ).unblock();
                $documents.append( `<div class="alert alert-danger mt-30" role="alert">${ errorMessage }</div>` );

                // Log.log( errorMessage );
            },
        } );
    }

    /**
     * renderItem
     *
     * @param {object} item
     */
    renderItem( item ) {
        return $( `
            <div class="c-account-documents__item">
                <div class="position-relative">
                    <a data-id="${ item.id }" href="javascript:void(0);" class="js-${ this.classes.remove } ${ this.classes.remove } ${ this.classes.remove } ${ this.classes.remove }" aria-label="${ spauto_settings.i18n.remove_image }" title="${ spauto_settings.i18n.remove_image }">
                        <img src="${ item.src }" alt="" class="c-account-avatar__img">

                        <svg class="${ this.classes.remove }-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="13 4.5 15 15">
                            <path d="M23.2 12l0 0 4.7 4.7 -2.8 2.8 -4.7-4.7 -4.7 4.7 -2.8-2.8 4.7-4.7 0 0 0 0 -4.7-4.7 2.8-2.8 4.7 4.7 4.7-4.7 2.8 2.8 -4.7 4.7L23.2 12z" fill="#fff"></path>
                        </svg>
                    </a>
                </div>
            </div>
        ` );
    }
}
